import store from 'redux/store';
import { status } from 'constants/general';
import { getAuthCookieInfo } from 'utils/functions/authentication';
import { initFirebase } from 'utils/libraries/firebase';
import { fetchLoginInfo } from 'modules/accountManagement/actions';
import {
  setContext,
  fetchFirebaseConfigSuccess,
  fetchFirebaseConfigFail,
} from 'modules/common/actions';

const initApp = context => {
  store.dispatch(setContext(context));

  const { authToken } = getAuthCookieInfo();
  if (
    authToken &&
    store?.getState()?.accountManagement?.loginInfo.status === status.SHOULD_CALL_API
  ) {
    const body = {
      headers: {
        Authorization: authToken,
      },
    };

    store.dispatch(fetchLoginInfo(body));
  }

  if (store?.getState()?.common?.firebaseConfig.status === status.SHOULD_CALL_API)
    initFirebase()
      .then(configObj => {
        store.dispatch(fetchFirebaseConfigSuccess(configObj));
      })
      .catch(() => {
        store.dispatch(fetchFirebaseConfigFail());
      });
};

export default initApp;
